import { QuickSwitchMenu } from '@dealstack/frontend/shared/components/QuickSwitch/QuickSwitchMenu';
import {
	isParentItem,
	QuickSwitchConfigItem,
} from '@dealstack/frontend/shared/components/QuickSwitch/QuickSwitchMenu.types';
import { useQuickSwitchConfig } from '@dealstack/frontend/shared/components/QuickSwitch/useQuickSwitchConfig';
import { generatePath, useParams } from 'react-router-dom';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';

interface Props {
	config?: QuickSwitchConfigItem[];
}

export const QuickSwitch = ({ config: configProp }: Props) => {
	const { dealId } = useParams();
	const config = useQuickSwitchConfig(configProp);

	const dealRoute = generatePath(ROUTES.DEAL, { dealId: dealId ?? '' });

	const menuItems = config.map((item) => {
		if (isParentItem(item)) {
			return {
				...item,
				items: item.items.map((subItem) => ({
					...subItem,
					route: generatePath(`${ROUTES.DEAL}${subItem.route}`, { dealId: dealId ?? '' }),
				})),
			};
		} else {
			return {
				...item,
				route: generatePath(`${ROUTES.DEAL}${item.route}`, { dealId: dealId ?? '' }),
			};
		}
	});

	return <QuickSwitchMenu menuItems={menuItems} dealRoute={dealRoute} />;
};
